module.exports = __webpack_public_path__ + "img/5.16d191a1.jpg";